export enum Sex {
  SEX_UNSET = 'SEX_UNSET', // Do not use, needed because of proto3 limitations
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  UNSPECIFIED = 'UNSPECIFIED',
}
